<template>
  <div
    :class="[
      {
        'page-has-left-panels page-has-right-panels':
          Object.keys(user).length !== 0,
      },
    ]"
  >
    <SPreloader />
    <SLandingTopBar v-if="!isUserAuthenticated"/>
    <SubHeaderCategories
      pageName="Search"
      :backButtonCategories="true"
      :categories="categories"
      :searchType="searchType"
      @clearFilter="clearFilter"
    />
    <div class="header-spacer"></div>
    <div class="container">
      <div class="row">
        <div
          class="col col-xl-12 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12 card-search-container"
          data-cy="divSearchResults"
        >
          <SShowResultBookmark :count="this.resultNumber" :total="totalResultsFunction" :categories="this.selectedCategories" />
          <SFilterBar
            class="ml-2"
            @button="makeFilter"
            @categoryButton="makeFilter"
            @sortby="makeFilter"
            @clearFilter="clearFilter"
            @removeFilter="removeFilter"
            :options="options"
            :choice="choice"
            :optionsType="optionsType"
            :optionsPrivacy="optionsPrivacy"
            :optionsCategory="optionsCategory"
            :optionsCondition="optionsCondition"
            :optionsSort="optionsSort"
            :startWith="startOption"
            :selectedFilters="selectedFilters"
            :startCategory="startCategory"
            :searchType="searchType"
            ref="sfilter"
          />
          <SLazyContent
            v-if="isSearching"
            :numberOfItems="3"
            data-cy="fetchingResults"
          />

          <LoadingSpinner position="relative" overlay="search-results" v-if="isLoading"/>

          <div id="search-item-gallery" v-if="!isLoading">
            <div
              v-for="(result, index) in filteredResults"
              class="md-layout-item"
              :key="index"
            >
              <SNewItemMaterial
                :item="result"
                @openWindowPopup="openChat(result)"
                :class="{
                  'item-unavailable':
                    result.status === itemStatus.RECEIVED ||
                    result.status === itemStatus.SENT,
                }"
                v-if="result.class === 'item'"
              />

              <SNewArrivalMaterialSearchResults
                :arrival="result"
                @openWindowPopup="openChat(result)"
                v-if="result.class === 'user'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      id="result-warning"
      buttonName="OK"
      :title="warningTitle"
      ref="modal"
      @button="closeModal()"
      class="font-weight-bold"
      >{{ warning }}</Modal
    >

    <CookiesAndPrivacy
      v-if="!storageCookies && Object.keys(user).length === 0"
      @cookies-privacy="accept"
    />
  </div>
</template>

<script>
import SShowResultBookmark from "@/components/atoms/SShowResultBookmark";
import SFilterBar from "@/components/molecules/SFilterBar";
import Modal from "@/components/atoms/Modal";
import item_status from "@/enum/item-status";
import item_sortby from "@/enum/sortby-options";
import { mapGetters, mapActions } from "vuex";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import SubHeaderCategories from "@/material-components/molecules/SubHeaderCategories.vue";
import SNewItemMaterial from "@/material-components/organisms/SNewItemMaterial";
import SNewArrivalMaterialSearchResults from "@/material-components/organisms/SNewArrivalMaterialSearchResults";
import CookiesAndPrivacy from "@/components/molecules/CookiesAndPrivacy";
import SLazyContent from "@/material-components/organisms/SLazyContent";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import UserHelper from "@/mixins/UserHelper.vue";
import axios from 'axios';
import Global from '../../constants/Global';

const headers = {
  'Content-Type': 'application/json'
};

export default {
  name: "SSearchResults",
  mixins: [ChatHelperVue, ItemHelperVue, UserHelper],
  components: {
    SShowResultBookmark,
    SFilterBar,
    Modal,
    SPreloader,
    SubHeaderCategories,
    SNewItemMaterial,
    SNewArrivalMaterialSearchResults,
    CookiesAndPrivacy,
    SLazyContent,
    SLandingTopBar,
    LoadingSpinner,
  },
  data() {
    return {
      isBottom: false,
      searchOffset: 48,
      scrolledPage: 0,
      searchResults: [],
      totalResults: [],
      selectedCategories: "",
      searchType: "",
      resultNumber: 0,
      prevRoute: null,
      isSearching: false,
      isLoading: false,
      canRedirect: false,
      redirectTo: null,
      itemStatus: item_status,
      selectedKeyChat: {},
      isBannerExpanded: false,
      selectedItemChat: null,
      warning: null,
      warningTitle: null,
      startOption: [],
      startCategory: [],
      filter: {
        options: [],
        itemType: [],
        itemCondition: [],
        itemSort: 1,
        privacy: [],
        itemCategory: [],
      },
      choice: {
        options: [],
        itemType: [],
        itemCondition: [],
        itemSort: 1,
        privacy: [],
        itemCategory: [],
      },
      options: [
        { label: "Item", value: "item", dataCy: "itemOption" },
        { label: "Group", value: "group", dataCy: "groupOption" },
        { label: "User", value: "user", dataCy: "userOption" },
      ],
      optionsType: [
        { value: 1, label: "Give", dataCy: "giveTrade" },
        { value: 2, label: "Receive", dataCy: "receiveTrade" },
        { value: 3, label: "Lend", dataCy: "lendTrade" },
        { value: 4, label: "Borrow", dataCy: "borrowTrade" },
      ],
      optionsPrivacy: [
        { value: 1, label: "Public", dataCy: "publicPrivacy" },
        { value: 2, label: "Private", dataCy: "privatePrivacy" },
      ],
      optionsCondition: [
        { value: 1, label: "New", dataCy: "newCondition" },
        { value: 2, label: "Like New", dataCy: "likeNewCondition" },
        { value: 3, label: "Used", dataCy: "usedCondition" },
        { value: 4, label: "Worn", dataCy: "wornCondition" },
      ],
      optionsSort: [
        { value: 1, label: "New to old", dataCy: "newOldSort" },
        { value: 2, label: "Old to new", dataCy: "oldNewSort" },
        { value: 3, label: "A-Z", dataCy: "aZSort" },
        { value: 4, label: "Z-A", dataCy: "zASort" },
        { value: 5, label: "Cheapest", dataCy: "cheapeast" },
        { value: 6, label: "Most expensive", dataCy: "mostExpensive" }
      ],
      optionsCategory: [
        { value: 8, label: "Book", icon: "book", dataCy: "bookCategory" },
        {
          value: 5,
          label: "Auto",
          icon: "directions_car",
          dataCy: "autoCategory",
        },
        {
          value: 3,
          label: "Clothing",
          icon: "checkroom",
          dataCy: "clothingCategory",
        },
        {
          value: 2,
          label: "Electronics",
          icon: "phone_android",
          dataCy: "electronicCategory",
        },
        {
          value: 9,
          label: "Family",
          icon: "child_friendly",
          dataCy: "familyCategory",
        },
        {
          value: 10,
          label: "Games",
          icon: "sports_esports",
          dataCy: "gamesCategory",
        },
        {
          value: 1,
          label: "Household",
          icon: "maps_home_work",
          dataCy: "householdCategory",
        },
        {
          value: 4,
          label: "Music",
          icon: "library_music",
          dataCy: "musicCategory",
        },
        {
          value: 11,
          label: "Sports",
          icon: "sports_football",
          dataCy: "sportsCategory",
        },
        { value: 12, label: "Tools", icon: "build", dataCy: "toolsCategory" },
        { value: 6, label: "Video", icon: "duo", dataCy: "videoCategory" },
        {
          value: 7,
          label: "Other",
          icon: "more_horiz",
          dataCy: "otherCategory",
        },
      ],
      categories: [
        {
          name: "free",
          icon: "sell",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/free?filter=13",
        },
        {
          name: "book",
          icon: "book",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/book?filter=8",
        },
        {
          name: "auto",
          icon: "directions_car",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/auto?filter=5",
        },
        {
          name: "clothing",
          icon: "checkroom",
          iconClass: "material-icons clothing-class",
          searchQuery: "/s-app/search-result/clothing?filter=3",
        },
        {
          name: "electronic",
          icon: "phone_android",
          iconClass: "material-icons electronic-class",
          searchQuery: "/s-app/search-result/electronic?filter=2",
        },
        {
          name: "family",
          icon: "child_friendly",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/family?filter=9",
        },
        {
          name: "games",
          icon: "sports_esports",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/games?filter=10",
        },
        {
          name: "household",
          icon: "maps_home_work",
          iconClass: "material-icons-outlined household-class",
          searchQuery: "/s-app/search-result/household?filter=1",
        },
        {
          name: "music",
          icon: "library_music",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/music?filter=4",
        },
        {
          name: "sports",
          icon: "sports_football",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/sports?filter=11",
        },
        {
          name: "tools",
          icon: "build",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/tools?filter=12",
        },
        {
          name: "video",
          icon: "duo",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/video?filter=6",
        },
        {
          name: "other",
          icon: "more_horiz",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/other?filter=7",
        },
      ],
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
    };
  },
  computed: {
    ...mapGetters({
      searchResult: "getSearchResult",
    }),
    selectedFilters() {
      let filters = [];
      this.options.forEach((filter) => {
        if (this.choice.options.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      this.optionsCategory.forEach((filter) => {
        if (this.choice.itemCategory.includes(filter.value) && filter.value !== ""){
          filters.push(filter);
        }
      });
      this.optionsCondition.forEach((filter) => {
        if (
          this.choice.itemCondition.includes(filter.value) &&
          filter.value !== ""
        )
          filters.push(filter);
      });
      this.optionsSort.forEach((filter) => {
        if (this.choice.itemSort === filter.value) {
          filters.push(filter);
        }
      });
      this.optionsType.forEach((filter) => {
        if (this.choice.itemType.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      this.optionsPrivacy.forEach((filter) => {
        if (this.choice.privacy.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });

      return filters;
    },
    filteredResults() {
      const ITEM_CATEGORY = this.filter.itemCategory.length > 0 ? true : false
      const ITEM_CONDITION = this.filter.itemCondition.length > 0 ? true : false
      const ITEM_TRADE_TYPE = this.filter.itemType.length > 0 ? true : false
      const ITEM_SORT_BY = this.filter.itemSort

      let filteredItems = this.searchResults

      if (ITEM_CATEGORY) {
        filteredItems = filteredItems.filter(item => this.filter.itemCategory.includes(item.category))
      }

      if (ITEM_CONDITION) {
        filteredItems = filteredItems.filter(item => this.filter.itemCondition.includes(item.condition))
      }

      if (ITEM_TRADE_TYPE) {
        filteredItems = filteredItems.filter(item => this.filter.itemType.includes(item.type))
      }

      if (ITEM_SORT_BY) {
        let SORT_TYPE = this.filter.itemSort

        if (SORT_TYPE === item_sortby.NEW_TO_OLD) {
          filteredItems.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
        }

        if (SORT_TYPE === item_sortby.OLD_TO_NEW) {
          filteredItems.sort((a, b) => a.createdAt.localeCompare(b.createdAt))
        }

        if (SORT_TYPE === item_sortby.ASC) {
          filteredItems.sort((a,b) => a.title.localeCompare(b.title))
        }

        if (SORT_TYPE === item_sortby.DESC) {
          filteredItems.sort((a,b) => b.title.localeCompare(a.title))
        }

        if (SORT_TYPE === item_sortby.CHEAPEAST) {
          filteredItems = this.swampumFormulaArray(filteredItems)
          filteredItems.sort((a,b) => a.swampumValue - b.swampumValue)
        }

        if (SORT_TYPE === item_sortby.MOST_EXPENSIVE) {
          filteredItems = this.swampumFormulaArray(filteredItems)
          filteredItems.sort((a,b) => b.swampumValue - a.swampumValue)
        }
      }

      this.resultCount(filteredItems)

      return filteredItems
    },
    totalResultsFunction() {
      const ITEM_CATEGORY = this.filter.itemCategory.length > 0 ? true : false
      const ITEM_CONDITION = this.filter.itemCondition.length > 0 ? true : false
      const ITEM_TRADE_TYPE = this.filter.itemType.length > 0 ? true : false

      let filteredMaxResults = this.totalResults

      if (ITEM_CATEGORY) {
        filteredMaxResults = filteredMaxResults.filter(item => this.filter.itemCategory.includes(item.category))
      }

      if (ITEM_CONDITION) {
        filteredMaxResults = filteredMaxResults.filter(item => this.filter.itemCondition.includes(item.condition))
      }

      if (ITEM_TRADE_TYPE) {
        filteredMaxResults = filteredMaxResults.filter(item => this.filter.itemType.includes(item.type))
      }
      return filteredMaxResults.length
    },
    storageCookies() {
      return this.cookiesPrivacy;
    },
  },
  methods: {
    ...mapActions(["searchAPI"]),
    swampumFormulaArray(filteredItems){
      let newSwampumArray = filteredItems.map(item => {
        return {
          ...item,
          swampumValue: this.createSwampumValue(item.points, item.cash)
        }
      })

      return newSwampumArray
    },
    createSwampumValue(points, cash){
      let value = 0

      if(points > 0 && cash === 0) {
        value = points
      }

      if(points === 0 && cash > 0) {
        value = cash * 100
      }

      if(points > 0 && cash > 0) {
        value = ((cash * 100) + points) / 2
      }

      return value
    },
    makeFilter(value) {
      this.filter = value;
    },
    resultCount(count) {
      this.resultNumber = count.length;
    },
    expand() {
      this.isBannerExpanded = true;
    },
    retract() {
      this.isBannerExpanded = false;
    },
    applyFilters(arr) {
      if (this.filter.itemType.length !== 0) {
        arr = arr.filter((item) => {
          return (
            this.filter.itemType.includes(item.type) &&
            this.filter.options.includes(item.class)
          );
        });
      }
      if (this.filter.itemCategory.length !== 0) {
        arr = arr.filter((item) => {
          return (
            this.filter.itemCategory.includes(item.category) &&
            this.filter.options.includes(item.class)
          );
        });
      }
      if (this.filter.itemCondition.length !== 0) {
        arr = arr.filter((item) => {
          return (
            this.filter.itemCondition.includes(item.condition) &&
            this.filter.options.includes(item.class)
          );
        });
      }
      return arr;
    },
    openChat(key) {
      const selectedKeyId = key.id ?? key.group.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        key.feedType = "NEW_ITEM";
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
        this.selectedKeyChat.messages = this.selectedKeyChat.messages.filter(
          (msg) => {
            return (
              msg.senderId === key.user.id || msg.receiverId === key.user.id
            );
          }
        );
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$refs.rightStickyBar.openClosePopup();
    },
    joinGroupWarning(warning) {
      this.warning = warning;
      this.warningTitle = "Join group";
      $("#result-warning").modal("show");
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    openTradeModal(itemId) {
      $(`#trade-item-${itemId}`).modal("show");
    },
    accept(a) {
      this.cookiesPrivacy = a;
    },
    async search() {
      this.isLoading = true

      let items_result = await axios.get(Global.getServerDomain() + '/bookmark?query=' + this.selectedCategories + '&searchType=' + this.searchType, { headers }).then(response => { return response.data })
      let users_result = await axios.get(Global.getServerDomain() + '/bookmark-users?query=' + this.selectedCategories + '&searchType=' + this.searchType, { headers }).then(response => { return response.data })
      let total_result = await axios.get(Global.getServerDomain() + '/totalItems?query=' + this.selectedCategories + '&searchType=' + this.searchType, { headers }).then(response => { return response.data })

      const items_and_users = [...items_result, ...users_result]
      const totalResult_and_users = [...total_result, ...users_result]

      this.resultCount(items_and_users)

      this.searchResults = items_and_users;
      this.totalResults = totalResult_and_users;

      this.isLoading = false
    },
    async searchNewResults() {
      let result = await axios.get(Global.getServerDomain() + '/scrollFetch?query=' + this.selectedCategories + '&searchType=' + this.searchType + '&offset=' + this.searchOffset, { headers }).then(response => { return response.data });

      this.searchResults = [...this.searchResults, ...result];
      this.resultCount(this.searchResults)
    },
    clearFilter() {
      this.choice = {
        options: [],
        itemType: [],
        itemCondition: [],
        itemSort: [],
        privacy: [],
        itemCategory: [],
      };
    },
    removeFilter(removed) {
      if (this.options.includes(removed)) {
        this.choice.options = this.choice.options.filter((filter) => {
          return filter !== removed.value;
        });
        if (removed.value === "item") {
          this.choice.itemType = [];
          this.choice.itemCondition = [];
          this.choice.itemCategory = [];
          this.choice.itemSort = [];
        }
        if (removed.value === "group") {
          this.choice.privacy = [];
        }
      } else if (this.optionsType.includes(removed)) {
        this.choice.itemType = this.choice.itemType.filter((filter) => {
          return filter !== removed.value;
        });
      } else if (this.optionsCondition.includes(removed)) {
        this.choice.itemCondition = this.choice.itemCondition.filter(
          (filter) => {
            return filter !== removed.value;
          }
        );
      } else if (this.optionsSort.includes(removed)) {
        this.choice.itemSort = this.choice.itemSort.filter(
          (filter) => {
            return filter !== removed.value;
          }
        );
      } else if (this.optionsPrivacy.includes(removed)) {
        this.choice.privacy = this.choice.privacy.filter((filter) => {
          return filter !== removed.value;
        });
      } else {
        this.choice.itemCategory = this.choice.itemCategory.filter((filter) => {
          return filter !== removed.value;
        });
      }
    },
    checkScrollBottom() {
      window.onscroll = () => {
        if (this.filteredResults.length < 24) {
          if (window.scrollY - this.scrolledPage > 50) {
            this.scrolledPage = window.scrollY;
            this.searchOffset = this.searchOffset + 48;
            this.searchNewResults();
            this.isBottom = true;
          } else {
            this.isBottom = false;  
          }
        } 
        else {
          if (window.scrollY - this.scrolledPage > 4000) {
            this.scrolledPage = window.scrollY;
            this.searchOffset = this.searchOffset + 48;
            this.searchNewResults();
            this.isBottom = true;
          } else {
            this.isBottom = false;  
          }
        }
      };
    },
  },
  watch: {
    isBottom(newValue) {
      if (typeof newValue === "boolean") {
        this.commitScrollStatus({ isBottom: newValue });
      }
    },
    $route(to) {
      const IS_CATEGORY_BUTTON = this.$route.fullPath.includes("?")

      if(IS_CATEGORY_BUTTON){
        this.searchType = 'category-button'
      }

      if(!IS_CATEGORY_BUTTON) {
        this.searchType = 'search-bar'
      }

      this.selectedCategories = to.params.query
      this.scrolledPage = 0
      this.searchOffset = 48
      this.search()
    },
  },
  async created() {
    const QUERY_FILTER_EXISTS = Object.hasOwn(this.$route.query, 'filter')

    if (QUERY_FILTER_EXISTS) {
      this.selectedCategories = this.$route.params.query
      this.searchType = 'category-button'
      this.search()
    }

    if (!QUERY_FILTER_EXISTS) {
      this.selectedCategories = this.$route.params.query
      this.searchType = 'search-bar'
      this.search()
    }

    const itemId = this.$route.query.sendTradeMessage;
    if (itemId) {
      $(() => {
        this.openTradeModal(itemId);
      });
    }

    const groupId = this.$route.query.askToJoinGroup;
    if (groupId) {
      $(() => {
        const ref = `group-${groupId}`;
        const groupCard = $(`.${ref}`)[0];
        groupCard.scrollIntoView(false);
        this.$refs[ref][0].openModal();
      }).catch(() => console.log("user not logged"));
    }

    const userId = this.$route.query.chatWithUser;
    if (userId) {
      $(() => {
        const ref = `user-${userId}`;
        const usarCard = $(`.${ref}`)[0];
        usarCard.scrollIntoView(false);
        this.$refs[ref][0].tryToOpenChat(userId);
      }).catch(() => console.log("user not logged"));
    }
  },
  updated() {
    $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  async mounted() {
    this.checkScrollBottom();

    if (this.prevRoute.path === "/s-app/item-activity") {
      this.$router.go();
    }
  },
  unmounted() {
    this.style.remove();
  },
};
</script>

<style scoped>
.container {
  margin-top: 100px;
  min-width: 100%;
  padding: 0 50px;
}
.register-button {
  margin: 1rem 0 0.5rem 0;
}
.banner-expand {
  max-height:1000px !important;
}
.show-more-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin: 0.5rem 1rem 0 1rem;
  color: black;
}
.display-none {
  display: none;
}
.bookmark-banner {
  width: 90%;
  min-height: 300px;
  background-image: linear-gradient(#668AAE, white);
  border-radius: 4px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.show-more-dropdown {
  cursor: pointer;
  color: #05919b;
  text-decoration: underline;
  margin: 0.5rem 0;
}
.bookmark-text {
  color: black;
  text-align: center;
  margin: 0.25rem 1rem;
  font-size: 1rem;
}
.link-text {
  text-decoration: underline;
}
#show-more-text p {
  margin-bottom: 0;
  font-size: 1rem;
}
.text-blocks {
  margin: 0.5rem 0;
}
.bookmark-header-text {
  color: black;
  font-weight: bold;
  text-align: center;
  font-size: 24px;
  line-height: 24px;
}
.bookmark-title {
  color: black;
  font-weight: bold;
  text-align: center;
  font-size: 40px;
  line-height: 40px;
  margin-top: 1rem;
}
.item-unavailable {
  filter: grayscale(100%);
}

.card-search-container {
  padding: 0 28px;
}

#search-item-gallery {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between !important;
}
#search-item-gallery > div {
  box-sizing: border-box;
}

.md-layout-item {
  margin: 0 8px 16px !important;
  padding: 0 !important;
  max-width: 576px;
}
</style>

<style lang="scss">
.page-has-left-panels {
  padding-left: 0 !important;
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .bookmark-banner {
    width: 100%;
  }
  .container {
    padding: 0 10px;
  }
}
@media screen and (max-width: 360px) {
  .bookmark-banner {
    min-height: 300px;
  }
  .bookmark-title {
    font-size: 32px;
    line-height: 32px;
  }
  .bookmark-header-text {
    font-size: 24px;
    line-height: 24px;
  }
}
</style>
